<template>
  <header class="header-container">
    <slot></slot>
  </header>
</template>

<script>
export default {
  name: "LayoutHeader",
};
</script>

<style scoped>
.header-container {
  background: #fff;
  border-bottom: #e4e4e7 1px solid;
}
</style>
